import { ENVIRONMENT_URL } from '../settings';

const ALLOWED_FILE_TYPES = {
  'image/jpeg': 'image',
  'image/png': 'image',
  'video/mp4': 'video',
  'video/quicktime': 'video',
  'application/pdf': 'pdf',
} as const;

type UploadFileParams = Readonly<{
  file: File;
  token: string;
}>;

export const isValidFileType = (file: File): boolean => {
  return Object.keys(ALLOWED_FILE_TYPES).includes(file.type);
};

export const uploadFile = async ({ file, token }: UploadFileParams) => {
  const mediaPayload = {
    type: ALLOWED_FILE_TYPES[file.type as keyof typeof ALLOWED_FILE_TYPES] || 'pdf',
    name: file.name,
    size: file.size.toString(),
  };

  const uploadUrlResponse = await fetch(`${ENVIRONMENT_URL}/media`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(mediaPayload),
  });

  if (!uploadUrlResponse.ok) {
    throw new Error('Failed to get upload URL');
  }

  const { upload_url: uploadUrl, id, uri } = await uploadUrlResponse.json();

  // Step 2: Upload the file to the pre-signed URL
  const uploadResponse = await fetch(uploadUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': file.type,
      'Content-Length': file.size.toString(),
    },
    body: file,
  });

  if (!uploadResponse.ok) {
    throw new Error('Failed to upload file');
  }

  return {
    mediaId: id,
    newDocumentUri: uri,
  };
};
